import BankingLedger from "../../../../Components/Banking/Ledger/Banking_Ledger";

export default function Ledger() {
  return <BankingLedger />;
}
